import type { CreateShareSavingsAccountForChildProcessPayload } from '@generated-types';
import type { ValidAccountApplicationContextType } from '@utils/process-form-utils';

export const getProcessPayloadFromAccountApplication = (
    accountApplication: ValidAccountApplicationContextType,
): CreateShareSavingsAccountForChildProcessPayload => ({
    child: { ...accountApplication.selectedChildEligibility.child },
    applicantParent: {
        ...accountApplication.selectedChildEligibility.currentBankCreateShareSavingsAccountEligibility.applicantParent,
        email: accountApplication.applicantParentEmail,
    },
    approverParent: {
        ...accountApplication.selectedChildEligibility.currentBankCreateShareSavingsAccountEligibility.approverParent,
        phoneNumber: accountApplication.notifyApproverParentOnPhoneNumber,
    },
    bankregnr:
        accountApplication.selectedChildEligibility.currentBankCreateShareSavingsAccountEligibility.bank.bankregnr,
    applicantParentHasGivenConsent: accountApplication.applicantParentHasGivenConsent,
});
